import { CalculatorQuestionType } from "@prisma/client";
import clsx from "clsx";
import { CalculatorAnswerTypes } from "../../../types/Co2CalculatorAnswerTypes";
import { hasAnswerDataOptions } from "../../util/calculator";
import { TSelectCurrentQuestion } from "../../util/prismaHelper";
import RadioAnswer from "./Answers/RadioAnswer";
import RangeAnswer from "./Answers/RangeAnswer";
import SelectAnswer from "./Answers/SelectAnswer";
import styles from "./QuestionLayout.module.scss";

export type QuestionLayoutProps = {
  question: string;
  questionId: string;
  questionHint?: string | null;

  answers?: TSelectCurrentQuestion["QAnswer"];
};

function QuestionLayout({
  question,
  questionHint,
  questionId,
  answers,
}: QuestionLayoutProps) {
  return (
    <>
      <div className={clsx(styles.titleContainer)}>
        <span className={styles.title}>{question}</span>
        {questionHint && <div className={styles.hint}>{questionHint}</div>}
      </div>
      {answers && (
        <div
          className={clsx(
            styles.content,
            answers.some((a) =>
              ((a.data as CalculatorAnswerTypes.BaseRadioData[]) || []).some(
                hasAnswerDataOptions
              )
            ) && styles.multi
          )}
        >
          {answers.map((a) =>
            a.type === CalculatorQuestionType.SELECT ? (
              <SelectAnswer key={a.id} qId={questionId} answer={a} />
            ) : a.type === CalculatorQuestionType.RADIO ? (
              <RadioAnswer key={a.id} qId={questionId} answer={a} />
            ) : a.type === CalculatorQuestionType.RANGE ? (
              <RangeAnswer key={a.id} answer={a} qId={questionId} />
            ) : (
              <div key={a.id}>
                {((a.data as any[]) || []).map((o) => (
                  <div key={o.id}>{o.option}</div>
                ))}
              </div>
            )
          )}
        </div>
      )}
    </>
  );
}

export default QuestionLayout;
